<template>
  <hr class="app-devider">
</template>

<script>
export default {
  name: 'app-devider',
}
</script>

<style lang="scss" scoped>

.app-devider {
  margin: 0 auto;
  opacity: 0.15;
  border: 1px solid #666666;
  border-bottom-width: 0;
  border-right-width: 0;
  border-left-width: 0;
  width: 100%;
}

</style>
